import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { HttpService } from '../../../services/http/http.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { FADE_IN } from '../../../util/animations/animation';
import { CommunicationService } from '../../../services/communication/communication.service';
/**
 * We can create a new dashboard by selecting add dashboard option from the sidebar, once the dashboard gets added it will show under dashboard in the sidebar based on ordered by updated date under the dashboard.
 */
@Component({
  selector: 'app-add-dashboard',
  templateUrl: './add-dashboard.component.html',
  styleUrls: ['./add-dashboard.component.scss'],
  animations: [FADE_IN]
})
export class AddDashboardComponent implements OnInit {
  dashboardForm: FormGroup;
  constructor(private FB: FormBuilder,
    private httpService: HttpService,
    private loader: LoaderService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private communicationService: CommunicationService) { }

  ngOnInit(): void {
    this.generateDashboardForm();
  }

  generateDashboardForm(){
    this.dashboardForm = this.FB.group({
      boardName: ['', [Validators.required]],
      boardDescription: ['', [Validators.required]]
    })
  }

  /**
   * This function is used to add the new dashbaord 
   */
  async addDashboard(){
    if(this.dashboardForm.valid){
      this.loader.show('progress');
      const payload = this.dashboardForm.value;
      await this.httpService.post('board', payload)
      .subscribe((response: any) => {
        this.loader.hide('progress');
        this.toastr.success('added successfully', 'Dashboard', {
          progressBar: true, timeOut: 3000
        });
        this.onClosePopup();
      }, error =>{
        this.loader.hide('progress');
        this.toastr.warning(error, 'Dashboard', {
          progressBar: true, timeOut: 3000
        });
      })
    }
  }

  onClosePopup(){
    this.dialog.closeAll();
  }
}
